import React from 'react';
import { prettyKey } from '../helpers/formatters';

const PortResponse = ({ data }) => (
  <div>
    {data.success !== undefined && <p>Success: {String(data.success)}</p>}
    {data.valid !== undefined && <p>Valid: {String(data.valid)}</p>}
    {data.message !== undefined && <p>{String(data.message)}</p>}
    {['port_info', 'details', 'errors'].map((attr) => (
      <div key={attr}>
        {data[attr] && (
          <div>
            <p>{prettyKey(attr)}:</p>
            <pre>{JSON.stringify(data[attr], null, 2)}</pre>
          </div>
        )}
      </div>
    ))}
  </div>
);

export default PortResponse;
